var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreesAlt6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6V11C21 12.9528 19.6006 14.5787 17.75 14.9298V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H6.25V16.9298C4.39935 16.5787 3 14.9528 3 13V8C3 5.79086 4.79086 4 7 4C9.20914 4 11 5.79086 11 8V13C11 14.9528 9.60065 16.5787 7.75 16.9298V21.25H16.25V14.9298C14.3994 14.5787 13 12.9528 13 11V6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesAlt6);
export default __webpack_public_path__ + "static/media/trees-alt-6.52f61bc26146482dfa9f004b5c88f37a.svg";
export { ForwardRef as ReactComponent };